import { BasicModel } from "@goodgamestudios/core";
import { BasicLanguageData } from "@goodgamestudios/core";

import { BasicAssetData } from "../../basic/model/components/BasicAssetData";

import { Poker2AchievementData } from "./components/Poker2AchievementData";
import { Poker2AvatarData } from "./components/Poker2AvatarData";
import { Poker2BuddyData } from "./components/Poker2BuddyData";
import { Poker2GiftData } from "./components/Poker2GiftData";
import { Poker2InventoryData } from "./components/Poker2InventoryData";
import { Poker2LobbyData } from "./components/Poker2LobbyData";
import { Poker2onTableData } from "./components/Poker2onTableData";
import { Poker2RankingData } from "./components/Poker2RankingData";
import { Poker2RegistrationData } from "./components/Poker2RegistrationData";
import { Poker2SessionData } from "./components/Poker2SessionData";
import { Poker2SharedObject } from "./components/Poker2SharedObject";
import { Poker2ShopData } from "./components/Poker2ShopData";
import { Poker2SitnGoData } from "./components/Poker2SitnGoData";
import { Poker2SocialData } from "./components/Poker2SocialData";
import { Poker2TournamentData } from "./components/Poker2TournamentData";
import { Poker2UserData } from "./components/Poker2UserData";
import { Poker2WodData } from "./components/Poker2WodData";

export class Poker2Model extends BasicModel {
    public static wodData: Poker2WodData;
    public static lobbyData: Poker2LobbyData;
    public static itemShop: Poker2ShopData;
    public static inventoryData: Poker2InventoryData;
    public static avatarData: Poker2AvatarData;
    public static onTableData: Poker2onTableData;
    public static onSitnGoData: Poker2SitnGoData;
    public static giftData: Poker2GiftData;
    public static tournamentData: Poker2TournamentData;
    public static rankingData: Poker2RankingData;
    public static buddyList: Poker2BuddyData;

    private static _registrationData: Poker2RegistrationData;

    public static eventIsActive: boolean = false;
    public static performanceMonitorInitialized = false;
    /** Unix timestamp transmitted by the server. Will be set GBDCommand. **/
    public static timestampServer: number;

    public static get registrationData(): Poker2RegistrationData {
        return Poker2Model._registrationData;
    }

    public static set registrationData(value: Poker2RegistrationData) {
        Poker2Model._registrationData = value;
    }
    public static get achievementData(): Poker2AchievementData {
        return BasicModel._achievementData as Poker2AchievementData;
    }
    public static set achievementData(value: Poker2AchievementData) {
        BasicModel._achievementData = value;
    }
    public static get sessionData(): Poker2SessionData {
        return Poker2Model._sessionData as Poker2SessionData;
    }
    public static set sessionData(value: Poker2SessionData) {
        Poker2Model._sessionData = value;
    }
    public static get userData(): Poker2UserData {
        return BasicModel._userData as Poker2UserData;
    }
    public static set userData(value: Poker2UserData) {
        BasicModel._userData = value;
    }
    public static get socialData(): Poker2SocialData {
        return BasicModel._socialData as Poker2SocialData;
    }
    public static set socialData(value: Poker2SocialData) {
        BasicModel._socialData = value;
    }
    public static get languageData(): BasicLanguageData {
        return BasicModel._languageData as BasicLanguageData;
    }

    /*		public static function get lobbyData():Poker2LobbyData {
                return _lobbyData as Poker2LobbyData;
            }

            public static function set lobbyData(value:Poker2LobbyData):void {
                        _lobbyData = value;
                    }*/

    public static get localData(): Poker2SharedObject {
        return BasicModel._localData as Poker2SharedObject;
    }

    public static set localData(value: Poker2SharedObject) {
        BasicModel._localData = value;
    }

    public static updateModelData(): void {
        Poker2Model.tournamentData.update();

    }

    public static __initialize_static_members() {
        Poker2Model.timestampServer = NaN;
    }
}

Poker2Model.__initialize_static_members();
